export const Status = [
    'new',
    'irrelevant',
    'inProgress',
    'recruited',
];
